import { render } from "./SpinWheel.vue?vue&type=template&id=4f40f3eb"
import script from "./SpinWheel.vue?vue&type=script&lang=js"
export * from "./SpinWheel.vue?vue&type=script&lang=js"

import "./SpinWheel.vue?vue&type=style&index=0&id=4f40f3eb&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__